/**
 * Possible duration steps to query by
 */
export enum FilterTimeStep {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

/**
 * Possible duration steps to query by
 */
export enum FilterTimeStepKey {
  Day = 'days',
  Week = 'weeks',
  Month = 'months',
  Year = 'years',
}

/**
 * Time presets for the picker
 */
export enum FilterTimePeriod {
  ThisWeek = 'this_week',
  LastWeek = 'last_week',
  Week = 'week',
  ThisMonth = 'this_month',
  LastMonth = 'last_month',
  Month = 'month',
  Custom = 'custom',
  ThisYear = 'this_year',
  LastYear = 'last_year',
  Last = 'past',
}

interface FilterParams {
  workspaceIds: number[]
  timePeriod: FilterTimePeriod
  fromDate?: string
  toDate?: string
  value?: number
  unit?: FilterTimeStep
  sort?: string
  sortAsc?: boolean
  page?: number
  pageSize?: number
}

export type FilterUserActionParams = Pick<FilterParams, 'sort' | 'sortAsc' | 'page' | 'pageSize'>

export type FilterTimeParams = Pick<FilterParams, 'timePeriod' | 'fromDate' | 'toDate' | 'value' | 'unit'>
